const PREFIX = 'PERIODS_';
export const GET_PERIODS = `${PREFIX}GET`;
export const SET_PERIODS = `${PREFIX}SET`;
export const GET_CLOSED_USAGE_PERIODS = `${PREFIX}GET_CLOSED_USAGE_PERIODS`;
export const SET_CLOSED_USAGE_PERIODS = `${PREFIX}SET_CLOSED_USAGE_PERIODS`;
export const GET_PERIODS_UNTIL_CURRENT = `${PREFIX}GET_PERIODS_UNTIL_CURRENT`;
export const SET_PERIODS_UNTIL_CURRENT = `${PREFIX}SET_PERIODS_UNTIL_CURRENT`;